/**
 * This module handles the search button (de)activation depending on input.
 *
 * @copyright TU Dresden
 * @date 24.11.2021
 *
 * The search buttons on the search flyout (#livesarch.search-form), the search page (#custom-form.search-form)
 * and the error page (#custom-form .search-form) are disabled by default.
 * A listener on the input field will activate the button, when anything was
 * entered or pasted into the field. When the field gets emptied, the button will be deactivated again.
 * This handling is just cosmetic. The search machinery does also check for a search term and rejects the search,
 * when the user somehow circumvented this measure.
 */

import $ from 'jquery';

import App from 'libs/app';

App.registerReadyHandler("search-button-activator", function () {
    // .search-form is the common marker for all three search displays
    // SearchableText is the common name for the input field
    // .button is the common marker for all three search buttons
    $(".search-form [name='SearchableText']").on("input", function (e) {
        $(".button", $(e.currentTarget).closest(":not(input)")).prop('disabled', !e.currentTarget.value);
    });
});